export enum FeatureStatusEnum {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
  Enabled = "ENABLED",
  Disabled = "DISABLED",
}